<template>
    <div class="table-box">
        <el-table :data="OptionsData" fit row-key="_key" :key="key">
            <el-table-column label="序号" width="72">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column :label="EnumField.Title" :width="EnumField.Width">
                <template slot-scope="scope">
                    <mx-panel
                        :type="EnumField.Link"
                        :value="scope.row[EnumField.Name]"
                        key=""
                        panel="SystemLine"
                        :config="{ Type: EnumField.Link }"
                    ></mx-panel>
                </template>
            </el-table-column>
            <el-table-column
                v-for="(col, index) in ShowColumns"
                :key="col.Name + '_' + index"
                :label="col.Title"
                :width="index > 0 ? col.Width : ''"
            >
                <template slot-scope="scope">
                    <mx-field  v-if="!scope.row._delete"
                        :key="scope.$index"
                        :type="col.Type"
                        :edit="true"
                        :name="col.Name"
                        :value="scope.row"
                        :one-line="true"
                        :config="col"
                        @change="FieldChange($event, scope.row, scope.$index)"
                    ></mx-field>
                    <span v-else>已经删除</span>
                </template>
            </el-table-column>
            <el-table-column align="right" label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        v-if="!scope.row._delete"
                        @click="handleDeleteItem(scope.row, scope.$index)"
                        ><span>删除</span></el-button
                    >
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-circle-plus-outline"
                        v-else
                        @click="handleDeleteItem(scope.row, scope.$index)"
                        ><span>启用</span></el-button
                    >
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import list from 'matrix.node.ui/master/list'
export default {
    mixins: [list.component, list.options],
    data() {
        return { OptionsData: [], key: new Date().getTime() }
    },
    methods: {
        handleDeleteItem(val, index) {
            let data = this.OptionsData[index]
            data._delete = !data._delete
            this.OptionsData = [].concat(this.OptionsData)
            this.key = new Date().getTime()
        },
        FieldChange(val, item, index) {
            let data = this.OptionsData[index]
            data[val.name] = val.value
        },
        GetValue() {
            let result = []
            for (let i = 0; i < this.OptionsData.length; i++) {
                let item = this.OptionsData[i]
                if (item._delete) {
                    if (item.Id) {
                        item._delete = true
                        result.push(item)
                    }
                } else {
                    let error
                    if (!error) {
                        result.push(item)
                    }
                }
            }
            return result
        },
        GetChange() {
            let result = []
            for (let i = 0; i < this.OptionsData.length; i++) {
                let item = this.OptionsData[i]
                if (item._delete) {
                    if (item.Id) {
                        item._delete = true
                        result.push({ Id: item.Id, _delete: true })
                    }
                } else {
                    let error
                    if (!error) {
                        let data = this.GetData(item[this.EnumField.Name])
                        let _item = Object.assign({}, item)
                        delete _item._delete
                        let def = this.$matrix.GetDef(_item, data)
                        if (def) {
                            delete def[this.EnumField.Name]
                            if (Object.keys(def).length > 0) {
                                if (item.Id) {
                                    def.Id = item.Id
                                } else {
                                    let op = item[this.EnumField.Name]
                                    def[this.EnumField.Name] = {
                                        Id: op.Id,
                                        Type: op.Type
                                    }
                                }
                                result.push(def)
                            }
                        }
                    }
                }
            }
            return result.length > 0 ? result : null
        }
    },
    created() {
        this.OptionsData = this.options.map((item) => {
            let data = JSON.parse(JSON.stringify(this.GetData(item)))
            data._delete = false
            data[this.EnumField.Name] = item
            return data
        })
    }
}
</script>
<style scoped>
.box {
    background-color: #f7f7f7;
    padding: 5px 10px 5px 5px;
    text-align: right;
    overflow-x: auto;
}
.table-box {
    width: 100%;
    overflow-x: auto;
    padding: 0;
    margin: 0;
}
</style>